function getRandom(array) {
  const randomIndex = Math.floor(Math.random() * array.length);
  const item = array[randomIndex];
  return item;
}

function shuffle(array) {
  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));

    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

function alphabetizeByProperty(array, property) {
  array.sort((a, b) => {
    const nameA = a[property].toUpperCase();
    const nameB = b[property].toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
  return array;
}

export { getRandom, shuffle, alphabetizeByProperty };
